
import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { done, errorImg } from '../../../utils/ImagePath';
import "./PaymentStatus.scss";
import { FaTimes } from 'react-icons/fa';
import { FaCloudDownloadAlt } from "react-icons/fa";
import { pdfDownloadStatusPage } from '../../../services/flight/flightServices';


const PaymentStatus = () => {
    const [paymentDetails, setPaymentDetails] = useState({ bookingId: '', status: '', bookingstatus: '' });
    let location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const bookingId = queryParams.get('bookingId');
        const status = queryParams.get('status');
        const bookingstatus = queryParams.get('bookingstatus');
        setPaymentDetails({ bookingId, status, bookingstatus });
    }, [location]);


    useEffect(() => {
        const hasReloaded = localStorage.getItem('hasReloaded');
        if (!hasReloaded) {
            const timeoutId = setTimeout(() => {
                localStorage.setItem('hasReloaded', 'true');
                window.location.reload();
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
    }, []);

    useEffect(() => {
        if (paymentDetails?.status !== "success") {
            const timer = setTimeout(() => {
                navigate("/");
            }, 30000);

            return () => clearTimeout(timer);
        }
    }, [paymentDetails?.status]);

    const [loading, setLoading] = useState(false);

    const pdfDownload = async () => {
        const bookingId = paymentDetails?.bookingId;
        if (!bookingId) return;

        setLoading(true);

        try {
            const response = await pdfDownloadStatusPage(bookingId);
            const file = new Blob([response], { type: 'application/pdf' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(file);
            link.href = url;
            link.setAttribute('download', 'ticket.pdf');
            document.body.appendChild(link);
            link.click();

            link.remove();
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading the PDF:', error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <div className="payment-status">
                <Card className="payment-status-card">
                    {paymentDetails?.status === "success" && paymentDetails?.bookingstatus === "success" ? (
                        // Case when both payment and booking status are success
                        <div className="status-container success">
                            <Link to='/' className='cancel-button'><FaTimes /> </Link>
                            <img loading="lazy" src={done} alt="Payment Successful" className="status-icon" />
                            <h1 className="status-title">Payment Successful</h1>
                            <p className="status-message">
                                <strong>Thank you!</strong>
                            </p>
                            <p>You have successfully completed your payment.</p>
                            <div className="payment-details">
                                <div className="detail-row">
                                    <p className="label"><strong>Booking ID:</strong></p>
                                    <p className="value">{paymentDetails?.bookingId}</p>
                                </div>

                                <div className="detail-row">
                                    <p className="label"><strong>Payment Status:</strong></p>
                                    <p className="value success">Success</p>
                                </div>

                                <div className="detail-row">
                                    <p className="label"><strong></strong></p>

                                    <button
                                        className="btn btn-primary border-0 d-flex justify-content-center align-items-center"
                                        onClick={pdfDownload}
                                        disabled={loading}
                                         aria-label="Download ticket"
                                    >
                                        <FaCloudDownloadAlt className='me-1' />
                                        {loading ? "Loading..." : "Download Ticket"}
                                    </button>

                                </div>

                            </div>
                        </div>
                    ) : paymentDetails?.status === "success" && paymentDetails?.bookingstatus === "failed" ? (
                        // Case when payment status is success but booking status is failed
                        <div className="status-container error">
                            <Link to='/' className='cancel-button'><FaTimes /> </Link>
                            <img loading="lazy" src={errorImg} alt="Payment Failed" className="status-icon" />
                            <h1 className="status-title error-title">Booking Failed </h1>
                            <p className="status-message">
                                <strong>We're sorry!</strong> Your payment was processed, but the booking could not be completed.
                            </p>
                            <div className="payment-details">
                                <div className="detail-row">
                                    <p className="label"><strong>Booking ID:</strong></p>
                                    <p className="value">{paymentDetails?.bookingId}</p>
                                </div>
                                <div className="detail-row">
                                    <p className="label"><strong>Payment Status:</strong></p>
                                    <p className="value success">Success</p>
                                </div>
                                <div className="detail-row">
                                    <p className="label"><strong>Booking Status:</strong></p>
                                    <p className="value failed">Failed</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        // Case when either payment or booking status is not success
                        <div className="status-container error">
                            <Link to='/' className='cancel-button'><FaTimes /> </Link>
                            <img loading="lazy" src={errorImg} alt="Payment Failed" className="status-icon" />
                            <h1 className="status-title error-title">Payment Failed </h1>
                            <p className="status-message">
                                <strong>We're sorry!</strong> Your payment could not be processed.
                            </p>
                            <div className="payment-details">
                                <div className="detail-row">
                                    <p className="label"><strong>Booking ID:</strong></p>
                                    <p className="value">{paymentDetails?.bookingId}</p>
                                </div>
                                <div className="detail-row">
                                    <p className="label"><strong>Payment Status:</strong></p>
                                    <p className="value failed">Failed</p>
                                </div>
                            </div>
                        </div>
                    )}

                </Card>
            </div>
        </>
    );
}

export default PaymentStatus;